// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3PWoj","content":"LayoutSettings_content__2z_lt"};